import React, { useState } from "react"
import ReactGA from "react-ga"
import soloSignup from "../../images/new-pricing/solo-signup.png"
import soloSendInvoice from "../../images/new-pricing/solo-send-invoice.png"
import starterSignup from "../../images/new-pricing/starter-signup.png"
import starterBusiness from "../../images/new-pricing/starter-business.png"
import starterClients from "../../images/new-pricing/starter-clients.png"
import starterPractice from "../../images/new-pricing/starter-practice.png"
import leftImage from "../../images/qbo/leftImage.svg"
import btnVectorImage from "../../images/solo/btn-vector.svg"
import btnVectorArrowImage from "../../images/luca-pay/btn-vector-arrow.svg"
import checkedIcon from "../../images/new-pricing/checked.svg"
import Modali, { useModali } from "../modal"
import lucapayIcon from "../../images/luca-pay/lucapay-logo.svg"

export default function AdvancePlan2({ myob = false, page, qbo = false }) {
  const [videoModal1, toggleVideoModal1] = useModali();
  const [videoModal2, toggleVideoModal2] = useModali();

  const [starterVideoModal1, toggleStarterVideoModal1] = useModali();
  const [starterVideoModal2, toggleStarterVideoModal2] = useModali();
  const [starterVideoModal3, toggleStarterVideoModal3] = useModali();
  const [starterVideoModal4, toggleStarterVideoModal4] = useModali();

  const requestDemoClick = () => {
    ReactGA.event({
      category: `${page}_Request demo related to advanced plan options_Green button`,
      action: `${page}_Request demo related to advanced plan options_Green button Clicked`,
    })
  }
  return (
    <div>
      <div className="flex flex-col justify-content-center">
        <div className="new-pricing__hero-ad-plan2 text-center lg:mx-auto">
          <div className="title text-lg">
            Free Access to LUCA Pay on All plans above
          </div>
          <div className="inner flex items-center pb-2 h-full mx-auto p-10">
            <div className="flex sm:flex-row justify-content-center items-center mx-auto px-2 sm:mt-0 mt-8">
              <ul className="text-15 text-brand list-none">
                <li className={`flex`}>
                  <img src={checkedIcon}/>
                  <div className={`ml-2`}>No interest, only a 4.5%<sup>**</sup> transaction fee applies, 4 monthly instalments</div>
                </li>
                <li className="mt-8 flex">
                  <img src={checkedIcon}/>
                  <div className={`ml-2`}>
                    Processing payment fees: Use of Credit Card and Direct debit capped at 1.6% + $3.50
                  </div>
                </li>
                <li>
                  <div className="text-gray-7 mt-3 text-xs sm:-mb-12 pt-3">
                    <sup>**</sup>LUCA Pay Fee has been changed from 3.5% to 4.5% as of May 20th, 2023
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {qbo && <div className="flex justify-center items-center mt-8 lg:mx-auto">
            <button className="request-btn flex justify-center focus:outline-none">
              Select Plan
            </button>
          </div>}
        </div>
        <div className="flex sm:flex-row flex-col mx-auto mt-4">
        {/*{!myob && !qbo &&*/}
        {/*<div className="new-pricing__hero-ad-plan2 card1 text-center mt-0">*/}
        {/*    <div className="title">Video Resources for Solo Plan</div>*/}
        {/*    <div className="inner flex items-center pb-2 h-full mx-auto sm:mt-0 mt-8">*/}
        {/*      <div className="flex justify-content-center items-center desc mx-auto px-2 ">*/}
        {/*        <img src={soloSignup} className="w-32 mr-3 cursor-pointer" onClick={toggleVideoModal1} />*/}
        {/*        <img src={soloSendInvoice} className="w-32 cursor-pointer" onClick={toggleVideoModal2} />*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>}*/}
          {myob || qbo && <div className="new-pricing__hero-ad-plan2 card2 text-center mt-0">
            <div className="title">Video resources for Starter & Standard Plan</div>
            <div className="inner flex items-center pb-2 h-full mx-auto">
              <div className="flex sm:flex-row justify-content-center items-center desc mx-auto px-1 sm:mt-0 mt-8">
              <img src={starterBusiness} className="w-32 cursor-pointer img lg:mr-3 mt-3" onClick={toggleStarterVideoModal2} />
              <img src={starterClients} className="w-32 cursor-pointer img lg:mr-3 mt-3" onClick={toggleStarterVideoModal3} />
              <img src={starterPractice} className="w-32 cursor-pointer img lg:mr-3 mt-3" onClick={toggleStarterVideoModal4} />
                <img src={starterSignup} className="w-32 cursor-pointer img mt-3" onClick={toggleStarterVideoModal1} />
              </div>
            </div>
          </div>}
        </div>
      </div>
      <>
      {/*  <div className="font-medium text-18">*/}
      {/*  Need more information or support?*/}
      {/*</div>*/}
        <div className='flex justify-content-center'>
          <a
            onClick={requestDemoClick}
            className="req-per-demo-btn cursor-pointer focus:outline-none flex items-center relative"
            href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus"
          >
            <div className='text mt-1'>Request Your personalised Demo</div>
            {myob &&
              <img src={btnVectorImage} className="arrow absolute" alt="right arrow" />}
            {qbo && <img src={leftImage} className="arrow absolute" alt="right arrow" />}

            <img src={btnVectorArrowImage} className="absolute vector-arrow" alt="right arrow" />

          </a>
        </div>
      </>
      <Modali.Modal {...videoModal1}>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/kGajZpdUa6s?autoplay=1&enable_js=1"
            title="Add to contact"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="autoplay"
          />
        </div>
      </Modali.Modal>
      <Modali.Modal {...videoModal2}>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/W837a-mj3NI?autoplay=1&enable_js=1"
            title="Send invoice"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="autoplay"
          />
        </div>
      </Modali.Modal>

      <Modali.Modal {...starterVideoModal1}>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/TsflMMUPW8c?autoplay=1&enable_js=1"
            title="Sign up"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="autoplay"
          />
        </div>
      </Modali.Modal>
      <Modali.Modal {...starterVideoModal2}>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/cnUr52rPFm4?autoplay=1&enable_js=1"
            title="Sign up"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="autoplay"
          />
        </div>
      </Modali.Modal>
      <Modali.Modal {...starterVideoModal3}>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/s7SjBsqaMF4?autoplay=1&enable_js=1"
            title="Sign up"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="autoplay"
          />
        </div>
      </Modali.Modal>
      <Modali.Modal {...starterVideoModal4}>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/sS56nIA9Th0?autoplay=1&enable_js=1"
            title="Sign up"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            allow="autoplay"
          />
        </div>
      </Modali.Modal>
    </div>
  )
}
